export default __webpack_public_path__ + "static/media/profileview.d349ebe9.png";